
import {
  Button,
  createStyles,
  Divider,
  Icon,
  makeStyles,
  Theme,
  Typography
} from "@material-ui/core";
import React from "react";
import clsx from 'clsx';
import { ArrowTooltip } from "./tooltips";
import { Scrollbars } from 'react-custom-scrollbars';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    verticalDivider: {
      padding: "0px 2px 0px 2px"
    },
    icons: {
      '& > .fa': {
        margin: theme.spacing(2),
      },
      display: "flex",
      padding: theme.spacing(0.5),
    },
    iconButton: {
      minWidth: "0px !important",
      flex: 1
    },
    iconSize: {
      fontSize: "1.0em",
      width: "auto"
    },
    success: {
      color: theme.palette.success.main
    },
    error: {
      color: theme.palette.error.main
    },
    disabled: {
      opacity: 0.3
    },
    standardIconColor: {
      color: "rgba(0, 0, 0, 0.54)"
    }
  })
);

export const DenseDivider = (props) => {
  const {spacing, ...other} = props;

  return (
    <Divider {...other} style={{
      marginTop: `${spacing}px`,
      marginBottom: `${spacing}px`
    }}/>
  );
};

export const IconToolBar = (props) => {
  const classes = useStyles();
  const {children, margin} = props;

  return (
    <div className={classes.icons} style={{
      marginLeft: `${margin}em`,
      marginRight: `${margin}em`
    }}>
      {children}
    </div>
  );
};

export const ToolBarDivider = () => {
  const classes = useStyles();

  return (
    <Typography className={classes.verticalDivider}>{"|"}</Typography>
  );
};

export const FontAwesomeIcon = (props) => {
  const classes = useStyles();
  const {icon, color, success, error, disabled, matchColor} = props;
  const errorColor = error ? classes.error : "";

  return (
    <Icon
      className={clsx(`fa fa-sm ${icon}`, classes.iconSize, {
        [classes.disabled]: disabled,
        [classes.standardIconColor]: matchColor
      })}
      color={color ? color : "primary"}
      classes={{
        colorPrimary: success ? classes.success : errorColor
      }}
    />
  );
};

export const ToolBarButton = (props) => {
  const classes = useStyles();
  const {icon, visible, title, onClick, color, success,
    error, disabled, ...other} = props;

  const isVisible = visible !== undefined ? visible : true;
  const tooltipText = disabled ? `${title} (Disabled)` : title;

  return (
    <React.Fragment>
      {isVisible && (<ArrowTooltip title={tooltipText}>
        <Button
          size="small"
          className={classes.iconButton}
          onClick={disabled ? undefined :onClick}
          {...other}
        >
          <FontAwesomeIcon
            icon={icon}
            error={error}
            color={color}
            success={success}
            disabled={disabled}
          />
        </Button>
      </ArrowTooltip>)}
    </React.Fragment>
  );
};

export const SlimScrollbar = (props) => {
  const {children} = props;

  return (
    <Scrollbars
      autoHide
      autoHideTimeout={250}
      autoHideDuration={100}
    >
      {children}
    </Scrollbars>
  );
};
